import React from 'react';
import { Button, Modal, connectModal, Alert } from '@gsa/afp-component-library';

function FundingValidModal({ handleClose, handleSubmit }) {
  return (
    <Modal
      onClose={handleClose}
      actions={
        <div
          style={{
            marginTop: '20px',
            display: 'flex',
            gap: '10px',
          }}
        >
          <Button
            type="button"
            variant="unstyled"
            onClick={handleClose}
            label="Cancel"
          />
          <Button
            type="button"
            variant="primary"
            onClick={() => {
              handleSubmit();
              handleClose();
            }}
            label="Submit to funding"
            leftIcon={{ name: 'arrow_forward' }}
          />
        </div>
      }
    >
      <Alert type="warning">
        This additonal request had been funded in the previous fiscal year.
      </Alert>
      <p>
        Please return the request for funding re-evaluation for the current
        fiscal year.
      </p>
    </Modal>
  );
}

export default connectModal(FundingValidModal);
